<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择出库单"
      width="1200px"
      top="8vh">
    <table-select
        ref="tableSelect"
        :columns="columnsProperty"
        :filter="filter"
        module="basic"
        url="outStockBills"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="出库单号">
            <el-input v-model.trim="filter.billNo" style="width: 140px" placeholder="请输入出库单号" clearable/>
          </el-form-item>
          <el-form-item label="关联单据">
            <el-input v-model.trim="filter.relBillNo" style="width: 160px" placeholder="请输入关联单据编号" clearable/>
          </el-form-item>
          <el-form-item label="出库日期">
            <el-date-picker
                v-model="outStorageDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="outStorageDateChange"
            />
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="createDateChange"
            />
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect";

  export default {
    name: "OutStockOrderSelect",
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          outStockType: 2,
          relBillNo: "",
          billNo: "",
          status: 2,
        },
        columnsProperty: [
          {
          tooltip: true,
            title: "单号",
            key: "billNo",
            width: 140,
            align: "center",
          },
          {
          tooltip: true,
            title: "关联单据编号",
            key: "relBillNo",
            width: 160,
            align: "center",
          },
          {
          tooltip: true,
            title: "出库时间",
            key: "requireDate",
            width: 180,
            align: "center",
          },
          {
          tooltip: true,
            title: "创建人",
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
          tooltip: true,
            title: "创建时间",
            key: "createTime",
            width: 180,
            align: "center",
          },
          {
          tooltip: true,
            title: "备注",
            key: "note",
            minWidth: 150,
          },
          {
            title: "操作",
            align: "center",
            width: 80,
            slot: "action",
            fixed: "left",
          },
        ],
        outStorageDate: "", // 出库日期
        createDate: "", // 制单日期
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },
      selectHandle(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },
      resetHandle(filter) {
        this.createDate = "";
        this.outStorageDate = "";
        this.filter = Object.assign(this.filter, filter);
      },
      outStorageDateChange(date) {
        if (date) {
          this.filter.requireDateBegin = date[0];
          this.filter.requireDateEnd = date[1];
        } else {
          this.filter.requireDateBegin = "";
          this.filter.requireDateEnd = "";
        }
      },
      createDateChange(date) {
        if (date) {
          this.filter.createTimeBegin = date[0];
          this.filter.createTimeEnd = date[1];
        } else {
          this.filter.createTimeBegin = "";
          this.filter.createTimeEnd = "";
        }
      },
    },
  };
</script>

<style scoped>

</style>